<template>
  <div class="main_box">
    <div class="main_bar" v-if="false">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <span class="currentSpan">待评项目分组</span>
        </el-breadcrumb-item>
      </el-breadcrumb>
      <div>
        <el-button @click="goBackEditVote()"> 返回编辑投票 </el-button>
        <el-button type="primary" @click="editProjectGroup(null)">
          新增分组1
        </el-button>
      </div>
    </div>
    <div class="main_body">
      <div class="form_bar">
        <div class="form_bar_search">
          <div class="condition_item"></div>
        </div>
        <div class="form_bar_btn">
          <el-button @click="goBackEditVote()" v-if="false">
            返回编辑投票
          </el-button>
          <el-button
            type="primary"
            @click="editProjectGroup(null)"
            v-if="meetingInfo.MeetingType === 0"
          >
            新增分组
          </el-button>
          <el-button
            type="primary"
            @click="editCommonProjectGroup(null)"
            v-if="meetingInfo.MeetingType === 2"
          >
            新增分组
          </el-button>
        </div>
      </div>
      <el-table
        v-loading="tableLoading"
        :data="projectGroupList"
        style="width: 100%"
      >
        <el-table-column
          type="index"
          :index="indexMethod"
          label="序号"
          width="60"
        ></el-table-column>
        <el-table-column
          :label="meetingInfo.MeetingType === 0 ? '项目组名称' : '分组名称'"
        >
          <template slot-scope="scope">
            <el-link
              type="primary"
              class="cell_link"
              @click.stop
              @click="projectManager(scope.row.Id)"
            >
              {{ scope.row.Name }}
            </el-link>
          </template>
        </el-table-column>
        <el-table-column label="排序" width="50" align="center" key="Sort">
          <template slot-scope="scope">
            <span>{{ scope.row.Sort }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="排序（投屏分组排序）"
          width="150"
          align="center"
          key="SupplementSort"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.SupplementSort }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="160">
          <template slot-scope="scope">
            <el-link
              type="primary"
              class="cell_link"
              @click.stop
              @click="projectManager(scope.row.Id)"
            >
              进入
            </el-link>
            <el-link
              type="primary"
              class="cell_link"
              @click.stop
              @click="editProjectGroup(scope.row.Id)"
              v-if="meetingInfo.MeetingType === 0"
            >
              编辑
            </el-link>
            <el-link
              type="primary"
              class="cell_link"
              @click.stop
              @click="editCommonProjectGroup(scope.row.Id)"
              v-if="meetingInfo.MeetingType === 2"
            >
              编辑
            </el-link>
            <el-link
              type="primary"
              class="cell_link"
              @click.stop
              @click="deleteProjectGroup(scope.row)"
              v-if="scope.row.VoteNames.length === 0"
            >
              删除
            </el-link>
            <el-popover placement="left" width="400" trigger="hover">
              <el-table :data="scope.row.VoteNames">
                <el-table-column width="400" label="被以下投票使用">
                  <template slot-scope="scope1">
                    <span>{{ scope1.row }}</span>
                  </template></el-table-column
                >
              </el-table>
              <el-link
                title="被以下投票使用"
                type="primary"
                class="cell_link"
                slot="reference"
                v-if="scope.row.VoteNames.length !== 0"
                :disabled="scope.row.VoteNames.length !== 0"
              >
                删除
                <i class="el-icon-connection el-icon--right"></i>
              </el-link>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination_box">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="listQuery.MaxResultCount"
          :layout="pagination_layout"
          :total="listTotalCount"
        >
        </el-pagination>
      </div>
      <EditProjectGroup
        :meetId="meetingId"
        :fatherSubmitDialog="editProjectGroupDialog"
        ref="editProjectGroup"
      ></EditProjectGroup>
      <CommonEditProjectGroup
        :meetId="meetingId"
        :fatherSubmitDialog="editProjectGroupDialog"
        ref="commonEditProjectGroup"
      ></CommonEditProjectGroup>
    </div>
  </div>
</template>
<script>
import voteProjectApi from '../../../api/vote/voteProject'
import EditProjectGroup from '@/components/project/EditProjectGroup.vue'
import CommonEditProjectGroup from '@/components/project/CommonEditProjectGroup.vue'
export default {
  name: 'ProjectGroup',
  components: {
    EditProjectGroup,
    CommonEditProjectGroup
  },
  data () {
    return {
      meetingId: null,
      tableLoading: true,
      projectGroupList: [],
      listTotalCount: 0,
      currentPage: 1,
      listQuery: {
        meetingId: null,
        maxResultCount: 10,
        skipCount: 0
      },
      pagination_layout: 'prev, pager, next'
    }
  },
  props: ['meetingInfo'],
  methods: {
    getProjectGroups: function () {
      this.tableLoading = true
      voteProjectApi.getProjectGroups(this.listQuery).then(data => {
        this.projectGroupList = data.Items
        this.listTotalCount = data.TotalCount
        this.tableLoading = false
      }).catch(err => {
        this.tableLoading = false
        return err
      })
    },
    indexMethod (index) {
      return this.listQuery.skipCount + index + 1
    },
    handleSizeChange (val) {
      this.listQuery.maxResultCount = val
      this.getProjectGroups()
    },
    handleCurrentChange (val) {
      this.listQuery.skipCount = (val - 1) * this.listQuery.maxResultCount
      this.getProjectGroups()
    },
    deleteProjectGroup: function (item) {
      let deleteMessage = '确认删除分组“' + item.Name + '”吗？'
      if (this.meetingInfo.MeetingType === 0) {
        deleteMessage = '确认删除项目组“' + item.Name + '”吗？'
      }
      this.$confirm(deleteMessage, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'custom_message_box'
      }).then(() => {
        const openLoading = this.openLoading('删除中…')
        voteProjectApi.deleteProjectGroup({
          projectGroupId: item.Id
        }).then(data => {
          openLoading.close()
          this.getProjectGroups()
          this.$message({
            type: 'success',
            message: '删除成功!',
            customClass: 'custom_message'
          })
        }).catch(err => {
          openLoading.close()
          return err
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
          customClass: 'custom_message'
        })
      })
    },
    editProjectGroup: function (projectGroupID) {
      this.$refs.editProjectGroup.openEditProjectGroup(projectGroupID)
    },
    editProjectGroupDialog: function () {
      this.getProjectGroups()
    },
    editCommonProjectGroup: function (projectGroupID) {
      this.$refs.commonEditProjectGroup.openEditProjectGroup(projectGroupID)
    },
    projectManager: function (projectGroupID) {
      this.$router.push({ name: 'voteProject', params: { mid: this.$route.params.mid, gid: projectGroupID, vid: this.$route.params.vid } })
    },
    goBackEditVote: function () {
      this.$router.push({ name: 'editVoteProject', params: { mid: this.$route.params.mid, vid: this.$route.params.vid } })
    }
  },
  computed: {

  },
  created () {
    this.meetingId = this.$route.params.mid
    this.listQuery.meetingId = this.$route.params.mid
    this.getProjectGroups()
    if (this.is_xs) {
      this.pagination_layout = 'total,prev, pager, next'
    } else {
      this.pagination_layout = 'total, sizes, prev, pager, next, jumper'
    }
  }
}
</script>
